interface CardProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'default' | 'gradient' | 'glass' | 'bordered' | 'flat';
  onClick?: () => void;
  padding?: 'none' | 'sm' | 'md' | 'lg';
}

export default function Card({
  children,
  className = '',
  variant = 'default',
  onClick,
  padding = 'md',
}: CardProps) {
  const variantClasses = {
    default:
      'bg-white border border-surface-border shadow-card dark:bg-gray-800 dark:border-gray-700',
    gradient:
      'bg-gradient-to-br from-white to-slate-50 border border-surface-border shadow-card dark:from-gray-800 dark:to-gray-900 dark:border-gray-700',
    glass:
      'glass border border-white/30 shadow-float dark:bg-gray-800/80 dark:border-gray-700/50',
    bordered:
      'bg-white border-2 border-surface-border dark:bg-gray-800 dark:border-gray-700',
    flat: 'bg-surface-muted dark:bg-gray-800/50',
  };

  const paddingClasses = {
    none: '',
    sm: 'p-4',
    md: 'p-5',
    lg: 'p-6',
  };

  return (
    <div
      onClick={onClick}
      className={`
        rounded-2xl
        ${variantClasses[variant]}
        ${paddingClasses[padding]}
        ${onClick ? 'cursor-pointer transition-all duration-200 hover:shadow-float hover:-translate-y-0.5' : ''}
        ${className}
      `}
    >
      {children}
    </div>
  );
}
